import { JOB_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IJob } from "../../shared/interfaces/job/IJob";

export const JobService = {
  get: (pagination: IPagination, type?: string): Promise<IBaseModel<IJob[]>> =>
    requests.get(JOB_URL, { ...pagination, type }),
  getSingle: (id: number): Promise<IJob> => requests.get(`${JOB_URL}/${id}`),
  create: (params: IJob) => requests.post(JOB_URL, params),
  update: (params: IJob, id: number) =>
    requests.put(`${JOB_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_URL}/${id}`),
  sort: (ids: number[]) => requests.patch(`${JOB_URL}/sort`, { ids }),
  sortMaterials: (id: number, params: { ids: number[] }) => 
    requests.patch(`${JOB_URL}/${id}/sort/material-data`, params),
  copy: (id: number) => requests.put(`${JOB_URL}/copy/${id}`),
};
